import { Component, OnInit, Directive, Input, TemplateRef, ViewChild, ElementRef } from '@angular/core';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';
import { BsModalService } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import { SessionService } from '../../../services/session.service';
import { Compra } from '../../../models/compra';
import { Lote } from '../../../models/lote';
import { CompraDetalle } from '../../../models/compra_detalle';
import { CompraService } from '../../../services/compra.service';
import { ProveedorModalComponent } from '../../modals/proveedor-modal/proveedor-modal.component';
import { EmitirRetencionCompraModalComponent } from '../../modals/emitir-retencion-compra-modal/emitir-retencion-compra-modal.component';
import { ProductoModalComponent } from '../../modals/producto-modal/producto-modal.component';
import { Validation } from '../../../config/validation';
import { SweetMessage } from '../../../config/sweet-message';
import { Message } from '../../../config/message';
import { Producto } from '../../../models/producto';
import { Proveedor } from '../../../models/proveedor';
import { ProveedorService } from '../../../services/proveedor.service';
import { Bodega } from '../../..//models/bodega';
import { BodegaService } from "../../../services/bodega.service";
import { ProductoService } from "../../../services/producto.service";
import { FormaPagoService } from '../../../services/forma-pago.service';
import { FormaPago } from '../../../models/forma-pago';
import { Caja } from '../../../models/caja';
import { CajaService } from '../../../services/caja.service';
import { ParametroService } from '../../../services/parametro.service';
import * as numeral from 'numeral';
import { Cheque } from '../../../models/cheque';
import { Tarjeta } from '../../../models/tarjeta';
import { Pago } from '../../../models/pago';
import { PagoDetalle } from '../../../models/pago_detalle';
import { Amortizacion } from '../../../models/amortizacion';
import { AmortizacionDetalle } from '../../../models/amortizacion_detalle';
import { NumberFormatPipe } from '../../../pipes/number-format.pipe';
import * as moment from 'moment';
import * as xml2js from 'xml2js';
import { ServicioModalComponent } from '../../modals/servicio-modal/servicio-modal.component';
import { DatosPagosComponent } from '../../../controls/datos-pago/datos-pago.component';
import { UtilsService } from '../../../services/utils.service';
import { TipoDocumento } from '../../../models/tipo-documento';
import { TipoComprobanteService } from '../../../services/tipo-comprobante.service';
import { ComprobanteService } from '../../../services/comprobante.service';
import { VentaDetalle } from '../../../models/venta_detalle';
import { Parser } from 'xml2js';
import { ProductoPrecioModalComponent } from '../../modals/producto-precio-modal/producto-precio-modal.component';
import { Transferencia } from '../../../models/transferencia';
import { LectorBarraModalComponent } from '../../modals/lector-barra-modal/lector-barra-modal.component';
import { OrdenCompraAddComponent } from '../orden-compra-add/orden-compra-add.component';
import { OrdenCompraService } from '../../../services/orden-compra.service';
import { OrdenCompra } from '../../../models/orden-compra';
import { OrdenCompraAddModalComponent } from '../../modals/orden-compra-add-modal/orden-compra-add-modal.component';
import { ImpuestoPorcentajeService } from '../../../services/impuesto-porcentaje.service';
import { FormasPagoFacturacionService } from '../../../services/formaspagofacturacion.service';
import { FormaPagoFacturacion } from '../../../models/forma-pago-facturacion';
import { PeriodoContableService } from '../../../services/periodo-contable.service';
import { ParametroContabilidadService } from '../../../services/parametro-contabilidad.service';
import { PeriodoContable } from '../../../models/periodo-contable';
import { ParametroContabilidad } from '../../../models/parametro-contabilidad';
import { AsientoContable } from '../../../models/asiento-contable';
import { AsientoContableDetalle } from '../../../models/asiento-contable-detalle';
import { SerieIngresoModalComponent } from '../../modals/serie-ingreso-modal/serie-ingreso-modal.component';

@Component({
	selector: 'app-compra-add',
	templateUrl: './compra-add.component.html',
	styleUrls: ['./compra-add.component.css'],
	providers: [
		CompraService,
		ComprobanteService,
		ProveedorService,
		BodegaService,
		ProductoService,
		SessionService,
		FormaPagoService,
		CajaService,
		ParametroService,
		NumberFormatPipe,
		TipoComprobanteService,
		OrdenCompraService,
		ImpuestoPorcentajeService,
		FormasPagoFacturacionService,
		ParametroContabilidadService,
        PeriodoContableService,
	],
})
export class CompraAddComponent implements OnInit {
	@ViewChild('autorizacionFocus') autorizacionElement: ElementRef;
	public title: String;
	public tipos: Array<TipoDocumento>;
	//public comprasDetalle: Array<CompraDetalle>;
	public compra: Compra;
	public msgSweet: SweetMessage;
	public msg: Message;
	public impuesto_id: number;
	public lote: Lote;
	public codigo: String;
	public cantidad;
	public fecha_elaboracion;
	public fecha_expiracion;
	private myForm: FormGroup;
	public vl: Validation;
	private producto: Producto;
	public IVA: number;
	public proveedor: Proveedor;
	topPrecios: Array<Compra> = [];
	compras: Array<CompraDetalle> = [];
	comprasXML: Array<CompraDetalle> = [];
	iva: number;
	validDateEmision: boolean = true;
	validDateCaducidad: boolean = true;
	valid: boolean = false;
	bodegas: Array<Bodega> = [];
	private productos: Array<Producto> = [];
	FormGroup = new Array();
	bsModalRef: BsModalRef;
	bsModalRefC: BsModalRef;
	public total_pago: number;
	//public Identif: string;
	public loading = false;
	public formasPago: Array<FormaPago>;
	public cambio: number;
	public cajas: Array<Caja>;
	public caja_id: String;
	public pago: Pago;
	public Mod_FactElec: string;
	public caja: Caja;
	public Mod_Inventario: string;
	public Mod_Cartera: string;
	public Mod_Contabilidad: string;
	public cheques: Array<Cheque>;
	public tarjetas: Array<Tarjeta>;
	public transferencias: Array<Transferencia>;
	public valorefectivo: number;
	public fecha_emision;
	public iva_vigente: boolean;
	public amortizacion: Amortizacion;
	public file: File;
	public fecha_actual;
	public fecha_MesAnt;
	public fecha_expir_ant;
	public detalle: String;
	public compra_detalle: CompraDetalle;
	public numero_decimales: number;
	public format_decimal: String;
	public retencion: boolean;
	public paso: number;
	public parser: Parser;
	public comprobante: any;
	//public correos: Array<any>;
	public permitirBotones: boolean;
	public is_compra: boolean;
	public Identif: string;
	@ViewChild(DatosPagosComponent) datosPagos: DatosPagosComponent;
	public calculo_decimales: number;
	public modal: boolean;
	public compra_id: String;
	public orden: OrdenCompra;
	public is_orden: boolean;
	public iva_id: number;
	public iva_porcentaje : any;
	public parametros: Array<any>;
	public formaspagofacturacion: Array<FormaPagoFacturacion>;
	public forma_pago_facturacion_id: String;
	public parametrosContabilidad: Array<ParametroContabilidad>;
	public periodoContable: PeriodoContable;
	public mask: any;

	constructor(
		private CompraService: CompraService,
		public tipoComprobanteService: TipoComprobanteService,
		private proveedorService: ProveedorService,
		private bodegaService: BodegaService,
		private productoService: ProductoService,
		private ss: SessionService,
		public fb: FormBuilder,
		private modalService: BsModalService,
		public formaPagoService: FormaPagoService,
		public cajaService: CajaService,
		private parametroService: ParametroService,
		public numberFormat: NumberFormatPipe,
		public utils: UtilsService,
		public comprobanteService: ComprobanteService,
		public ordenService: OrdenCompraService,
		public impuestoPorcentajeService: ImpuestoPorcentajeService,
		public formasPagoFacturacionService: FormasPagoFacturacionService,
		private parametroContabilidadService: ParametroContabilidadService,
        private periodoContableService: PeriodoContableService,
	) {
		this.tipos = [];
		this.title = "Factura compra";
		this.Identif = "";
		//this.Identif = "";
		this.IVA = 0;
		this.total_pago = 0;
		this.formasPago = [];
		this.cambio = 0;
		this.cajas = [];
		this.pago = new Pago();
		this.Mod_FactElec = this.ss.getData("mod_felectronica");
		this.Mod_Inventario = this.ss.getData("mod_inventario");
		this.Mod_Cartera = this.ss.getData("mod_cartera");
		this.Mod_Contabilidad = this.ss.getData("mod_contabilidad");
		this.cheques = [];
		this.tarjetas = [];
		this.transferencias = [];
		//this.comprasDetalle = [];
		this.compra = new Compra();
		this.valorefectivo = 0;
		this.fecha_emision = moment(this.fecha_emision);
		this.fecha_actual = moment(this.fecha_actual);
		this.fecha_MesAnt = moment(this.fecha_actual.subtract(1, 'months'));
		this.amortizacion = new Amortizacion();
		this.caja = new Caja();
		this.lote = new Lote();
		this.codigo = "";
		this.cantidad = "";
		this.fecha_elaboracion = moment(this.fecha_elaboracion);
		this.fecha_expiracion = moment(this.fecha_expiracion);
		this.fecha_expir_ant = moment(this.fecha_elaboracion.subtract(1, 'months'));
		this.detalle = "";
		this.compra_detalle = new CompraDetalle();
		this.numero_decimales = 2;
		this.format_decimal = "0,0.00";
		this.calculo_decimales = 2;
		this.modal = false;
		this.retencion = false;
		this.compra_id = "";
		this.paso = 1;
		this.parser = new Parser();
		this.comprobante = [];
		this.permitirBotones = false;
		this.is_compra = false;
		this.orden = new OrdenCompra();
		this.is_orden = false;
		this.impuesto_id = 0;
		this.iva_id = 0;
		this.parametros = [];
		this.iva_porcentaje = 0;
		//this.correos = [];
		this.formaspagofacturacion = [];
		this.forma_pago_facturacion_id = "";
		this.parametrosContabilidad = [];
		this.periodoContable = new PeriodoContable();
		this.mask = [ /[0-9]/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/,/\d/,/\d/,/\d/,/\d/,/\d/,];
	}

	ngOnInit() {
		this.msgSweet = new SweetMessage();
		this.msg = new Message();
		this.vl = new Validation();
		this.compra = new Compra();
		this.producto = new Producto();
		this.proveedor = new Proveedor();
		this.is_compra = true;
		this.onForm();
		//	this.isValidBotones();
		let p1 = this.getBodegas();
		let p2 = this.getTiposComprobante();
		let p3 = this.getParametros();
		let p4 = this.getParamNumeroDecimales();
		let p5 = this.getIVA(129);
		let p6 = this.getBodegaBySucursal();
		let p7 = this.getFormasPagoFacturacion();
		let p8 = null;
		if( this.Mod_Cartera && this.Mod_Contabilidad ) {
			p8 = this.getParametroContabilidadCompras();
		}
		this.loading = true;
		
		

		this.loading = true;
		Promise.all([p1, p2, p3, p4,p5, p6,p7, p8]).then(
			res => this.loading = false,
			err => this.loading = false
		);
	}


	onForm() {
		// this.FormGroup["serie"] = { required: true, max: 3, min: 3, valid: false, n: 0 };
		// this.FormGroup["punto_emision"] = { required: true, max: 3, min: 3, valid: false, n: 0 };
		// this.FormGroup["secuencial"] = { required: true, min: 1, valid: false, n: 0 };
		this.FormGroup["numero_autorizacion"] = { required: true, max: 50, min: 17, valid: false, n: 0 };
		this.FormGroup["compras"] = { required: true, valid: false, n: 0 };
		this.FormGroup["proveedor_id"] = { required: true, valid: false, n: 0 };
		this.FormGroup["bodega_id"] = { required: true, valid: false, n: 0 };
		this.FormGroup["numero_documento"] = { required: true,  valid: false, n: 0,max: 17,min:7 };

	}

	onIniDate() {
		let today = new Date();
		let dd = today.getDate();
		let mm = today.getMonth() + 1; //January is 0!
		let dia = "";
		let mes = "";

		var yyyy = today.getFullYear();
		dia = "" + dd;
		mes = "" + mm;
		if (dd < 10) {
			dia = "0" + dd;
		}
		if (mm < 10) {
			mes = "0" + mm;
		}
		let today2 = dia + '/' + mes + '/' + yyyy;
		this.compra.fecha_emision = today2;
	}

	getIVA(id) {
		return new Promise((resolve, reject) => {

			this.impuestoPorcentajeService.getById(id).subscribe(
				res => {
					this.iva_porcentaje = (res.porcentaje*100)/100;
					this.IVA = parseFloat(this.iva_porcentaje) / 100;
					this.recalcularItem(this.compra_detalle);
					resolve(true);
				},
				err => {
					this.iva_porcentaje = 0;
					this.IVA = 0;
					reject(err);
				}
			);

			
		});
	}

	getParametros() {
		return new Promise((resolve, reject) => {
			let qs ="?impuesto_id=2&is_tarifa=1&is_vigente=1&is_comprobante=1";
			this.impuestoPorcentajeService.getAll(qs).subscribe(
				res => {
					this.parametros = res.data;
					this.iva_id = this.parametros[0].id;
					resolve(true);
				},
				err => {
					this.parametros = [];
					reject(err);
				}
			);

		});
	}

	onChangeIva(id) {
		this.loading = true;

		this.getIVA(id).then(
			res => this.loading = false,
			err => this.loading = false,
		);
	}

	getTiposComprobante() {
		return new Promise((resolve, reject) => {
			// if(this.Mod_FactElec){
			//     this.Identif = "4,2";
			// }
			// else{
			//     this.Identif = "1,2";
			// }
			this.Identif = "1,2";
			this.tipoComprobanteService.getAll("?in[id]=" + this.Identif + "&sort=nombre").subscribe(
				res => {
					if (res.data.length) {
						this.tipos = res.data;
						this.compra.tipo_comprobante_id = this.tipos[0].id;
					} else {
						this.tipos = [];
					}
					resolve(true);
				},
				err => {
					this.tipos = [];
					reject(err);
				}
			);
		});
	}

	getParamNumeroDecimales() {
		return new Promise((resolve, reject) => {
			let numero_decimales = 19;
			this.parametroService.getById(numero_decimales).subscribe(
				res => {
					this.numero_decimales = res.valor;

					let digitos = "";
					for (let i = 0; i < this.numero_decimales; i++) digitos += "0";

					this.datosPagos.numero_decimales = this.numero_decimales;
					this.datosPagos.setFormat();

					this.format_decimal = "0,0." + digitos
					resolve(true);
				},
				err => {
					this.numero_decimales = 2;
					this.format_decimal = "0,0.00"
					reject(err);
				}
			);
		});
	}

	get formatDecimal() {
		return this.format_decimal;
	}

	getBodegas() {
		return new Promise((resolve, reject) => {
			let qs = '?sucursal_id=' + this.ss.getData('sucursal_id');
			this.bodegaService.getAll(qs).subscribe(
				res => {
					if (!res.data.length) {
						this.bodegas = [];
					} else {
						this.bodegas = res.data;
					}
					resolve(true);
				},
				err => {
					this.bodegas = [];
					reject(err);
				}
			);
		});
	}

	getBodegaBySucursal(){
        return new Promise((resolve, reject) => {
            if( !this.Mod_Inventario ){
                this.compra.bodega_id = "1"; // BODEGA POR DEFECTO / SUCURSAL 1
                resolve(true);
            }else{
                this.bodegaService.getAll("?sucursal_id=" + this.ss.getData('sucursal_id')).subscribe(
                    res => {
                        this.compra.bodega_id = res.data[0].id;
                        resolve(true);
                    },
                    err => {
                        this.compra.bodega_id = "";
                        reject()
                    }
                );
            }
        });
	}
	
	getFormasPagoFacturacion(){
        return new Promise((resolve, reject) => {
            this.formasPagoFacturacionService.getAll().subscribe(
                res => {
                    this.formaspagofacturacion = res.data;
                    resolve(true);
                },
                err => {
                    this.formaspagofacturacion = [];
                    reject();
                }
            );
        });
	}
	
	getPeriodoActual(){
        return new Promise((resolve, reject) => {
            let qs = "?periodo=" + moment(this.compra.fecha_emision).format('YYYY');
            this.periodoContableService.getPeriodoActual(qs).subscribe(
                res => {
                    this.periodoContable = res;
                    resolve(true);
                },
                err => {
                    reject(err);
                }
            );
        });
    }

    getParametroContabilidadCompras(){
        return new Promise((resolve, reject) => {
			// let qs = "?in[id]=9,11,16,17,18,20,22&embed=cuentacontable";
			let qs = "?in[tipo]=C,P&embed=cuentacontable";
			this.parametroContabilidadService.getAll(qs).subscribe(
				res => {
					let is_confirmedParametros = true;
					this.parametrosContabilidad.forEach(parametroContabilidad => {
						if( parametroContabilidad.cuenta_contable_id == null ){
							is_confirmedParametros = false;
							return false;
						}
					});
					if(!is_confirmedParametros){
						this.msgSweet.showMessage('error-message', "Por favor, confirmar los parámetros de las cuentas contables.");
					}else{
						this.parametrosContabilidad = res.data;
					}
					resolve(true);
				},
				err => {
					reject(err);
				}
			);
            
        });
	}

	setValueAsientoContable(){
        
        let asientoContable = new AsientoContable();
        let asientoContableCobros = new AsientoContable();
        asientoContable.fecha_emision = this.compra.fecha_emision;
        asientoContable.tipocomprobante = this.compra.tipocomprobante;
        asientoContable.tipo_comprobante_id = this.compra.tipo_comprobante_id;
        asientoContable.periodo_contable_id = this.periodoContable.id;
        asientoContable.numero_documento = this.compra.numero_documento;
		asientoContable.descripcion = this.proveedor.nombre_comercial;
		asientoContable.status = 'A';
        asientoContable.empresa_id = this.compra.empresa_id;
        asientoContable.usuario_id = this.compra.usuario_id;
        asientoContable.total = this.compra.total;
        asientoContableCobros.fecha_emision = this.compra.fecha_emision;
        asientoContableCobros.tipocomprobante = this.compra.tipocomprobante;
        asientoContableCobros.tipo_comprobante_id = this.compra.tipo_comprobante_id;
        asientoContableCobros.periodo_contable_id = this.periodoContable.id;
        asientoContableCobros.numero_documento = this.compra.numero_documento;
        asientoContableCobros.descripcion = this.proveedor.nombre_comercial;
        asientoContableCobros.empresa_id = this.compra.empresa_id;
        asientoContableCobros.usuario_id = this.compra.usuario_id;
        asientoContableCobros.total = this.compra.total;
        asientoContableCobros.status = 'A';
        let valor = 0;
		let valor_cheque= 0;
		let valor_tarjetas = 0;
		let valor_transferencias = 0;
		this.cheques.forEach(c=> {
			valor_cheque += Number(c.valor);
		});
		this.tarjetas.forEach(c=> {
			valor_tarjetas += Number(c.valor);
		});
		this.transferencias.forEach(c=> {
			valor_transferencias += Number(c.valor);
		});
		let isServicios = true;

		// this.compra.detalle.forEach(detalle => {
		// 	if(!detalle.es_servicio) isServicios = false; 
		// });

		this.compra.detalle.forEach(detalle => {
			if(detalle.tipo_producto_id != '2') isServicios = false; 
		});

        this.parametrosContabilidad.forEach(parametroContabilidad => {
            let asientoContableDetalle = new AsientoContableDetalle;
            asientoContableDetalle.empresa_id = asientoContable.empresa_id;
			asientoContableDetalle.usuario_id = asientoContable.usuario_id;
			if(!isServicios){
				if(parametroContabilidad.id == '15'){
					asientoContableDetalle.haber = parametroContabilidad.tipo_saldo=='H'?this.compra.total:0;
					asientoContableDetalle.debe = parametroContabilidad.tipo_saldo=='D'?this.compra.total:0;
					asientoContableDetalle.cuenta_contable_id = parametroContabilidad.cuenta_contable_id;
					asientoContableDetalle.cuenta = parametroContabilidad.cuentacontable;
					// asientoContable.detalle.push(asientoContableDetalle);   
					if(parametroContabilidad.tipo_saldo == 'H'){
						asientoContable.detalle.push(asientoContableDetalle);
						// asientoContableCobros.detalle.push(asientoContableDetalle);
					}else{
						asientoContable.detalle.unshift(asientoContableDetalle);
						// asientoContableCobros.detalle.unshift(asientoContableDetalle);   
					}     
				}
				if( parametroContabilidad.id == "19" && this.compra.iva ) {
					asientoContableDetalle.haber = parametroContabilidad.tipo_saldo=='H'?this.compra.iva:0;
					asientoContableDetalle.debe = parametroContabilidad.tipo_saldo=='D'?this.compra.iva:0;
					// asientoContableDetalle.haber = this.compra.subtotal;
					asientoContableDetalle.cuenta_contable_id = parametroContabilidad.cuenta_contable_id;
					asientoContableDetalle.cuenta = parametroContabilidad.cuentacontable;
					// asientoContableCobros.detalle.push(asientoContableDetalle);
					if(parametroContabilidad.tipo_saldo == 'H'){
						// asientoContable.detalle.push(asientoContableDetalle);
						asientoContableCobros.detalle.push(asientoContableDetalle);
					}else{
						// asientoContable.detalle.unshift(asientoContableDetalle);
						asientoContableCobros.detalle.unshift(asientoContableDetalle);   
					}     
				}
			}
			
			if(this.compra.tipo == "CO" && (parametroContabilidad.id == "23" || parametroContabilidad.id == "24" || parametroContabilidad.id == "25" || parametroContabilidad.id == "26" )){
				asientoContableDetalle.cuenta_contable_id = parametroContabilidad.cuenta_contable_id;
				asientoContableDetalle.cuenta = parametroContabilidad.cuentacontable;
				asientoContableDetalle.haber = parametroContabilidad.tipo_saldo=='H'?this.compra.total:0;
				asientoContableDetalle.debe = parametroContabilidad.tipo_saldo=='D'?this.compra.total:0;

				if( parametroContabilidad.id == "23" && this.valorefectivo > valor_cheque && this.valorefectivo > valor_tarjetas && this.valorefectivo > valor_transferencias ) {
					// asientoContableCobros.detalle.push(asientoContableDetalle);
					if(parametroContabilidad.tipo_saldo == 'H'){
						// asientoContable.detalle.push(asientoContableDetalle);
						asientoContableCobros.detalle.push(asientoContableDetalle);
					}else{
						// asientoContable.detalle.unshift(asientoContableDetalle);
						asientoContableCobros.detalle.unshift(asientoContableDetalle);   
					}     
				}
				else if( parametroContabilidad.id == "24" && valor_cheque > this.valorefectivo && valor_cheque > valor_tarjetas && valor_cheque > valor_transferencias ) {	
					// asientoContableCobros.detalle.push(asientoContableDetalle);
					if(parametroContabilidad.tipo_saldo == 'H'){
						// asientoContable.detalle.push(asientoContableDetalle);
						asientoContableCobros.detalle.push(asientoContableDetalle);
					}else{
						// asientoContable.detalle.unshift(asientoContableDetalle);
						asientoContableCobros.detalle.unshift(asientoContableDetalle);   
					}     
				}
				else if(  parametroContabilidad.id == "25" && valor_tarjetas > this.valorefectivo && valor_tarjetas > valor_cheque && valor_tarjetas > valor_transferencias ) {
					// asientoContableCobros.detalle.push(asientoContableDetalle);
					if(parametroContabilidad.tipo_saldo == 'H'){
						// asientoContable.detalle.push(asientoContableDetalle);
						asientoContableCobros.detalle.push(asientoContableDetalle);
					}else{
						// asientoContable.detalle.unshift(asientoContableDetalle);
						asientoContableCobros.detalle.unshift(asientoContableDetalle);   
					}     
				}
				else if( parametroContabilidad.id == "26"  && valor_transferencias > this.valorefectivo && valor_transferencias > valor_tarjetas && valor_transferencias > valor_cheque ) {
					// asientoContableCobros.detalle.push(asientoContableDetalle);
					if(parametroContabilidad.tipo_saldo == 'H'){
						// asientoContable.detalle.push(asientoContableDetalle);
						asientoContableCobros.detalle.push(asientoContableDetalle);
					}else{
						// asientoContable.detalle.unshift(asientoContableDetalle);
						asientoContableCobros.detalle.unshift(asientoContableDetalle);   
					}     
				}else if( parametroContabilidad.id == "23" && this.valorefectivo) {
					// asientoContableCobros.detalle.push(asientoContableDetalle);
					if(parametroContabilidad.tipo_saldo == 'H'){
						// asientoContable.detalle.push(asientoContableDetalle);
						asientoContableCobros.detalle.push(asientoContableDetalle);
					}else{
						// asientoContable.detalle.unshift(asientoContableDetalle);
						asientoContableCobros.detalle.unshift(asientoContableDetalle);   
					}     
				}
			}else if(this.compra.tipo == "CR"){
				if( parametroContabilidad.id == "17" ) {
					asientoContableDetalle.cuenta_contable_id = parametroContabilidad.cuenta_contable_id;
					asientoContableDetalle.cuenta = parametroContabilidad.cuentacontable;
					asientoContableDetalle.haber = parametroContabilidad.tipo_saldo=='H'?this.compra.total:0;
					asientoContableDetalle.debe = parametroContabilidad.tipo_saldo=='D'?this.compra.total:0;
					// asientoContableCobros.detalle.push(asientoContableDetalle);
					if(parametroContabilidad.tipo_saldo == 'H'){
						// asientoContable.detalle.push(asientoContableDetalle);
						asientoContableCobros.detalle.push(asientoContableDetalle);
					}else{
						// asientoContable.detalle.unshift(asientoContableDetalle);
						asientoContableCobros.detalle.unshift(asientoContableDetalle);   
					}     
				}
			}
		});
		let subtotal = 0;
        let subtotalCobro = 0;
        this.compra.detalle.forEach(compraDetalle => {
			
			// subtotal = (!compraDetalle.es_servicio && compraDetalle.graba_iva?(Number(compraDetalle.subtotal)+Number(compraDetalle.iva)):compraDetalle.subtotal);
			subtotal = (compraDetalle.tipo_producto_id != '2' && compraDetalle.graba_iva?(Number(compraDetalle.subtotal)+Number(compraDetalle.iva)):compraDetalle.subtotal);
			if(!isServicios){
				
				let asientoContableDetalle = new AsientoContableDetalle();
				asientoContableDetalle.empresa_id = asientoContable.empresa_id;
				asientoContableDetalle.usuario_id = asientoContable.usuario_id;
				asientoContableDetalle.cuenta_contable_id = compraDetalle.cuenta_inventario_id;
				let parametroContabilidad = this.parametrosContabilidad.filter(parametro => parametro.id == '30')[0];
				parametroContabilidad.tipo_saldo ="D";
				asientoContableDetalle.debe = parametroContabilidad.tipo_saldo=='D'?(subtotal?subtotal:compraDetalle.total):0;
				asientoContableDetalle.haber = parametroContabilidad.tipo_saldo=='H'?(subtotal?subtotal:compraDetalle.total):0;
				let cuenta = asientoContable.detalle.filter( asientoDetalle=> compraDetalle.cuenta_inventario_id!="0" && asientoDetalle.cuenta_contable_id == compraDetalle.cuenta_inventario_id );
				
				if( cuenta.length > 0 ) {
					let indexAsientoDetalle = asientoContable.detalle.findIndex(detalle => detalle.cuenta_contable_id === cuenta[0].cuenta_contable_id);
					asientoContable.detalle[indexAsientoDetalle].cuenta_contable_id = compraDetalle.cuenta_inventario_id
					asientoContable.detalle[indexAsientoDetalle].haber +=  parametroContabilidad.tipo_saldo=='H'?(subtotal?subtotal:compraDetalle.total):0;
					asientoContable.detalle[indexAsientoDetalle].debe +=  parametroContabilidad.tipo_saldo=='D'?(subtotal?subtotal:compraDetalle.total):0;
					
				}else if( cuenta.length == 0 && compraDetalle.cuenta_inventario_id !="0" ) {
					// asientoContable.detalle.push(asientoContableDetalle);
					if(parametroContabilidad.tipo_saldo == 'H'){
						asientoContable.detalle.push(asientoContableDetalle);
						// asientoContableCobros.detalle.push(asientoContableDetalle);
					}else{
						asientoContable.detalle.unshift(asientoContableDetalle);
						// asientoContableCobros.detalle.unshift(asientoContableDetalle);   
					}     
				}
			}
			// subtotalCobro = (compraDetalle.es_servicio && compraDetalle.graba_iva?(Number(compraDetalle.subtotal)+Number(compraDetalle.iva)):compraDetalle.subtotal);
			subtotalCobro = (compraDetalle.tipo_producto_id == '2' && compraDetalle.graba_iva?(Number(compraDetalle.subtotal)+Number(compraDetalle.iva)):compraDetalle.subtotal);
			let asientoContableDetalleCobro = new AsientoContableDetalle();
			asientoContableDetalleCobro.empresa_id = asientoContableCobros.empresa_id;
            asientoContableDetalleCobro.usuario_id = asientoContableCobros.usuario_id;
			asientoContableDetalleCobro.cuenta_contable_id = compraDetalle.cuenta_costo_gasto_id;
			
			let parametroContabilidadCobro = this.parametrosContabilidad.filter(parametro => parametro.id == '29')[0];
			parametroContabilidadCobro.tipo_saldo = "D";
			asientoContableDetalleCobro.debe = parametroContabilidadCobro.tipo_saldo=='D'?subtotalCobro:0;
			asientoContableDetalleCobro.haber = parametroContabilidadCobro.tipo_saldo=='H'?subtotalCobro:0;
			
			let cuentaCobro = asientoContableCobros.detalle.filter( asientoDetalle=> compraDetalle.cuenta_costo_gasto_id!="0" && asientoDetalle.cuenta_contable_id == compraDetalle.cuenta_costo_gasto_id );
			
			if( cuentaCobro.length > 0 ) {
				let indexAsientoDetalle = asientoContableCobros.detalle.findIndex(detalle => detalle.cuenta_contable_id === cuentaCobro[0].cuenta_contable_id);
				asientoContableCobros.detalle[indexAsientoDetalle].cuenta_contable_id = compraDetalle.cuenta_costo_gasto_id
				asientoContableCobros.detalle[indexAsientoDetalle].haber +=  (parametroContabilidadCobro.tipo_saldo=='H'?subtotalCobro:0);
				asientoContableCobros.detalle[indexAsientoDetalle].debe +=  (parametroContabilidadCobro.tipo_saldo=='D'?subtotalCobro:0);
				
			}else if( cuentaCobro.length == 0 && compraDetalle.cuenta_costo_gasto_id !="0" ) {
				// asientoContableCobros.detalle.unshift(asientoContableDetalleCobro);
				if(parametroContabilidadCobro.tipo_saldo == 'H'){
                    // asientoContable.detalle.push(asientoContableDetalleCobro);
					asientoContableCobros.detalle.push(asientoContableDetalleCobro);
                }else{
					// asientoContable.detalle.unshift(asientoContableDetalleCobro);
                    asientoContableCobros.detalle.unshift(asientoContableDetalleCobro);   
                }     
			}
		});
		if(!isServicios){
            this.compra.asientosContables.push(asientoContable);
        }
		this.compra.asientosContables.push(asientoContableCobros);
    }
	
	

	getNumeroDocumento(event){
		let numero_documento = event.target.value;
		this.compra.serie = numero_documento.split('-')[0];
		this.compra.punto_emision = numero_documento.split('-')[1];
		this.compra.secuencial = numero_documento.split('-')[2];

		
		setTimeout(()=>{ 
			if(this.compra.secuencial && this.compra.secuencial.length == 9){
				this.autorizacionElement.nativeElement.focus();
				
			}
		},0);
		
		this.calcularCuotasCredito();

	}

	validTypeMsgModel(campo, model) {

		let length = model.length;
		let temp = this.FormGroup[campo];
		if (temp.required && length == 0) {
			return this.msg.required;
		}
		if (length < temp.min) {
			return this.msg.lengthMin;
		}
		if (length > temp.max) {
			return this.msg.lengthMax;
		}

	}

	onkeyUp(event, campo) {
		if (this.FormGroup[campo].n == 0) {
			if (event.target.value.length > 0) {
				this.FormGroup[campo].n = 1;
			}
		}
	}

	onChangeSelect(event, campo) {
		if (this.FormGroup[campo].n == 0) {
			this.FormGroup[campo].n = 1;
		}
		if (event.target.value.length > 0) {
			this.FormGroup[campo].valid = true;
		}
		else {
			this.FormGroup[campo].valid = false;
		}
	}

	onValidCamp() {
		let i = 0;
		for (i = 0; i < Object.keys(this.FormGroup).length; i++) {
			var item = Object.keys(this.FormGroup)[i];
			if (!this.FormGroup[item]['valid']) {
				this.valid = true;
				return true;
			}
		}
		this.valid = false;
		return false;
	}

	// onSearchProducto(compraDetalle?) {
	// 	this.bsModalRef = this.modalService.show(ProductoModalComponent, Object.assign({}, {class: 'modal-xlg', initialState}));

	// 	this.bsModalRef.content.sendObject.take(1).subscribe((value) => {
	// 		this.sendObjectProducto(value,compraDetalle)
	// 	});
	// 	/*if( compraDetalle )
	// 		this.seleccionarProducto(compraDetalle);*/
	// }
	onSearchProducto() {

		const initialState = { bodega_id: this.compra.bodega_id, numero_decimales: this.numero_decimales, es_comprado: 1, tipo_producto_id: '1' };
		this.bsModalRef = this.modalService.show(ProductoPrecioModalComponent, Object.assign({}, { class: 'modal-xlg', initialState }));

		this.bsModalRef.content.sendProductoPrecio.subscribe((value) => {

			// value.precio = 0;
			let incluye_precio = false;
			// this.impuesto_id= value.impuesto_iva_id;
			this.sendObjectProducto(value,incluye_precio);
			// if (this.impuesto_id != 0) {
			// 	this.getImpuestoPorcentaje(this.impuesto_id);
			// }
		});


	}

	onSearchConsumible() {

		const initialState = { bodega_id: this.compra.bodega_id, numero_decimales: this.numero_decimales, es_comprado: 1, tipo_producto_id: '3' };
		this.bsModalRef = this.modalService.show(ProductoPrecioModalComponent, Object.assign({}, { class: 'modal-xlg', initialState }));

		this.bsModalRef.content.sendProductoPrecio.subscribe((value) => {

			// value.precio = 0;
			let incluye_precio = false;
			// this.impuesto_id= value.impuesto_iva_id;
			this.sendObjectProducto(value,incluye_precio);
			// if (this.impuesto_id != 0) {
			// 	this.getImpuestoPorcentaje(this.impuesto_id);
			// }
		});


	}


	openEmitirRetencionCompraModal() {
		this.modal = true;
		const initialState = { compra_id: this.compra_id, modal: this.modal };
		this.bsModalRef = this.modalService.show(EmitirRetencionCompraModalComponent, Object.assign({}, { class: 'modal-xlg', initialState }));

		this.bsModalRef.content.cerrarModal.take(1).subscribe((value) => {
			if (value.isSaved) {
				this.retencion = false;
			}
		});
	}

	onBarCode() {
		//this.bsModalRef = this.modalService.show(template);
		if (!this.compra.tipo_comprobante_id) {
			this.msgSweet.showMessage('error-message', "Seleccione el tipo de comprobante");
			return;
		}

		if (!this.compra.bodega_id) {
			this.msgSweet.showMessage('error-message', "Seleccione la bodega");
			return;
		}
		const initialState = { bodega_id: this.compra.bodega_id };
		this.bsModalRef = this.modalService.show(LectorBarraModalComponent, Object.assign({}, { class: '', initialState }));
		this.bsModalRef.content.sendProducto.subscribe((value) => {
			
			let producto: Producto = value;
			let incluye_precio = true;
			this.sendObjectProducto(producto,incluye_precio);
		});
	}

	onSearchServicio() {
		const initialState = { numero_decimales: this.numero_decimales, es_comprado: 1 };
		this.bsModalRef = this.modalService.show(ServicioModalComponent, Object.assign({}, { class: 'modal-xlg', initialState }));

		this.bsModalRef.content.sendProductoPrecio.subscribe((value) => {
			let item = { ...value };
			//item = {...value};
			item['precio'] = 0;
			item['unidadmedida'] = {};
			item['unidadmedida']['nombre'] = value.unidad;
			item['codigo'] = value.codigo;
			item['nombre'] = value.nombre;
			item['id'] = value.id;
			item['tipo_producto_id'] = value.tipo_producto_id;
			item['producto'] = value.es_servicio;
			let incluye_precio = false;
			this.sendObjectProducto(item,incluye_precio);
		});
	}

	getProductos() {
		this.loading = true;
		this.productoService.getAll().subscribe(
			res => {
				this.loading = false;
				if (!res.length) {
					this.productos = [];
				} else {
					this.productos = res;
				}
			},
			err => {
				this.loading = false;
				this.productos = [];
			}
		);
	}

	sendObjectProducto(event,incluye_precio) {
		let compraDetalle = new CompraDetalle();
		if (this.comprasXML.length > 0) {
			compraDetalle.producto_id = event.id;
			compraDetalle.producto.id = event.id;
			compraDetalle.producto.codigo = event.codigo;
			compraDetalle.producto.nombreEquivalente = event.nombre;
			compraDetalle.producto.graba_iva = event.graba_iva;
			compraDetalle.tipo_producto_id = event.tipo_producto_id;
			// compraDetalle.producto.es_servicio = event.es_servicio;
			compraDetalle.cuenta_ingreso_id = event.cuenta_ingresos_id;
			compraDetalle.cuenta_inventario_id = event.cuenta_inventario_id;
			this.comprasXML.forEach(e => {
				if (e.producto.nombreEquivalente != "") {
					this.permitirBotones = true;
				} else {
					this.permitirBotones = false;
				}
			});

		} else {
			let producto = event;
			let compra_detalle = new CompraDetalle();

			// compra_detalle.producto = producto;
			// compra_detalle.es_servicio = producto.es_servicio;
			// compra_detalle.producto_id = producto.id;
			// compra_detalle.usuario_id = this.ss.getData('usuario_id');
			// compra_detalle.empresa_id = this.ss.getData('empresa_id');
			// compra_detalle.sucursal_id = this.ss.getData('sucursal_id');

			// this.compras.push(compra_detalle);
			// this.calcularCuotasCredito();

			// venta_detalle.cantidad_stock = producto.cantidad_stock;
			// venta_detalle.cantidad = (producto.cantidad?producto.cantidad:1);

			// compra_detalle.es_servicio = producto.es_servicio;
			compraDetalle.tipo_producto_id = event.tipo_producto_id;
			compra_detalle.descripcion = producto.descripcion;
			compra_detalle.producto = producto.nombre;
			compra_detalle.codigo = producto.codigo;
			compra_detalle.unidad = producto.unidad;
			compra_detalle.producto_id = producto.id;
			compra_detalle.if_uso_lote = producto.if_uso_lote;
			// this.if_uso_lote = compra_detalle.if_uso_lote;
			compra_detalle.graba_iva = producto.graba_iva;
			// compra_detalle.precio_unitario = (producto.precio ? producto.precio : 0);
			(incluye_precio)?compra_detalle.precio_unitario = producto.precio:compra_detalle.precio_unitario = 0;

			compra_detalle.cantidad = (producto.cantidad ? producto.cantidad : 1);

			
			compra_detalle.cuenta_ingreso_id = producto.cuenta_ingreso_id;
			compra_detalle.cuenta_inventario_id = producto.cuenta_inventario_id;
			compra_detalle.cuenta_costo_gasto_id = producto.cuenta_costo_gasto_id;
			// if (this.is_orden) {
			// 	compra_detalle.cantidad = producto.cantidad;
			// 	compra_detalle.precio_unitario = this.utils.redondear(producto.precio, this.numero_decimales);
			// }else{

			// }



			//compra_detalle.subtotal = compra_detalle.cantidad * compra_detalle.precio_unitario;
			compra_detalle.subtotal = this.utils.redondear((compra_detalle.cantidad * compra_detalle.precio_unitario), this.calculo_decimales);

			compra_detalle.total = compra_detalle.subtotal + compra_detalle.iva;
			compra_detalle.usuario_id = this.ss.getData('usuario_id');
			compra_detalle.empresa_id = this.ss.getData('empresa_id');
			compra_detalle.sucursal_id = this.ss.getData('sucursal_id');

			// this.ventasDetalle.push(venta_detalle);
			this.compras.push(compra_detalle);
			this.recalcularFactura();
			this.calcularCuotasCredito();
		}
		this.recalcularFactura();

	}



	onSearchProveedor(event) {
		if (event.keyCode === 13) {
			if (this.proveedor.dni.toString().trim().length == 0) {
				this.proveedor = new Proveedor();
				return;
			} else {
				this.proveedorService.getByDni(this.proveedor.dni).subscribe(
					res => {
						this.loading = false;
						if (res.length > 0) {
							this.proveedor = res[0];
						} else {
							this.proveedor = new Proveedor();
							this.openDialogProveedor();
						}
					},
					err => {
						this.loading = false;
						this.openDialogProveedor();
					}
				);
			}
		}
	}

	openDialogProveedor() {
		const initialState = {};
		this.bsModalRef = this.modalService.show(ProveedorModalComponent, Object.assign({}, { class: 'modal-xlg', initialState }));

		this.bsModalRef.content.sendProveedor.take(1).subscribe((value) => {
			this.sendObjectProveedor(value);
		});
	}

	sendObjectProveedor(event) {
		//obtencion del producto que envia el componente producto-modal
		this.proveedor = event;
		this.retencion = false;
	}

	onMakeNumeroDocumento(campo) {
		if (campo == "serie" || campo == "punto_emision" || campo == "secuencial") {
			this.compra.numero_documento = this.compra.serie + "-" + this.compra.punto_emision + "-" + this.compra.secuencial;
		}
	}

	onValidDateEmision() {
		return this.vl.validDate(this.fecha_emision.toString());
	}

	recalcularItem(compra_detalle: CompraDetalle, event?) {

		compra_detalle.subtotal = (compra_detalle.cantidad * compra_detalle.precio_unitario) - compra_detalle.desc_valor;
		compra_detalle.subtotal = this.utils.redondear(compra_detalle.subtotal, this.calculo_decimales);

		compra_detalle.iva = parseFloat(compra_detalle.subtotal.toString()) * parseFloat(this.IVA.toString());
		this.recalcularFactura();
		this.calcularCuotasCredito();
		//this.calcularTotal(this.total_pago);
		// this.calcularFactura();
	}

	onKeyUp(event, compra_detalle: CompraDetalle) {
		compra_detalle.cantidad = event.target.value;
		this.calcularItem(compra_detalle.precio_unitario, compra_detalle);
	}

	onChange(event, compra_detalle: CompraDetalle) {
		compra_detalle.precio_unitario = event.target.value;
		this.calcularItem(compra_detalle.precio_unitario, compra_detalle);
	}

	calcularItem(precio_unitario: number, compra_detalle: CompraDetalle) {
		compra_detalle.precio_unitario = precio_unitario;
		compra_detalle.subtotal = compra_detalle.precio_unitario * compra_detalle.cantidad;
		compra_detalle.iva = compra_detalle.subtotal * this.iva;
		compra_detalle.total = compra_detalle.subtotal + compra_detalle.iva;
		//this.calcularFactura();
	}

	recalcularFactura() {
		this.compra.subtotal_iva12 = 0;
		this.compra.subtotal_iva0 = 0;
		this.compra.iva = 0;
		this.compra.total = 0;

		let tipo_comprobante_id = parseInt(this.compra.tipo_comprobante_id.toString());

		this.compras.forEach(obj => {

			/*if( tipo_comprobante_id === 1 && obj.graba_iva ){
				this.compra.subtotal_iva12 += obj.subtotal;
			}else{
				this.compra.subtotal_iva0 += obj.subtotal;
			}*/


			if ((tipo_comprobante_id === 1 && obj.graba_iva) || (tipo_comprobante_id === 4 && obj.graba_iva)) {
				this.compra.subtotal_iva12 += obj.subtotal;
				this.compra.subtotal_iva12 = this.utils.redondear(this.compra.subtotal_iva12, this.calculo_decimales);
			} else {
				this.compra.subtotal_iva0 += obj.subtotal;
			}
		});

		if (this.compra.desct_valor.toString().trim().length === 0) {
			this.compra.desct_valor = 0;
		}
		//let desc_valor = parseFloat(this.compra.desct_valor.toString());
		this.compra.subtotal = parseFloat(this.compra.subtotal_iva0.toString()) + parseFloat(this.compra.subtotal_iva12.toString());
		this.compra.subtotal = parseFloat(this.compra.subtotal.toString()) - parseFloat(this.compra.desct_valor.toString());

		this.compra.subtotal = this.utils.redondear(this.compra.subtotal, this.calculo_decimales);

		//this.compra.iva = Math.round((this.compra.subtotal * this.IVA) * 100) / 100;
		//this.compra.iva = Math.round(((this.compra.subtotal_iva12 - this.compra.desct_valor) * this.IVA) * 100) / 100;
		this.compra.iva = this.utils.redondear(((this.compra.subtotal_iva12 - this.compra.desct_valor) * this.IVA), this.calculo_decimales);

		//this.compra.iva = Math.round((this.compra.subtotal * this.IVA) * 100) / 100;
		this.compra.total = this.compra.subtotal + this.compra.iva;
		this.compra.total = this.utils.redondear(this.compra.total, this.calculo_decimales);

		//CALCULAR CAMBIO
		let saldo = this.compra.total - this.compra.abonado;

		if (this.compra.retencion) {
			saldo = saldo - this.compra.retencion.total;
		}

		this.cambio = (this.total_pago > saldo ? (this.total_pago - saldo) : 0);
		//this.cambio = Math.round( this.cambio * 100) / 100;
		this.cambio = this.utils.redondear(this.cambio, this.calculo_decimales);
	}

	setValuePagos() {
		this.pago.detalle = [];
		this.pago.fecha_pago = moment(this.fecha_emision).format("YYYY-MM-DD");
		this.pago.saldo = this.compra.total;

		if( this.Mod_Cartera ){
            this.pago.recibido = this.total_pago;
            this.pago.cambio = this.cambio;
        }else{
            this.pago.recibido = this.compra.total;
            this.pago.cambio = 0;
        }
		
		//this.pago.compra_id = this.compra.id;
		this.pago.detalle = [];
		//this.pago.caja_id = this.ss.getData("caja_id");
		this.pago.empresa_id = this.ss.getData("empresa_id");
		this.pago.sucursal_id = this.ss.getData("sucursal_id");
		this.pago.usuario_id = this.ss.getData("usuario_id");

		if( this.Mod_Cartera ){
			if (this.valorefectivo > 0) {
				let pago_detalle = new PagoDetalle();
				pago_detalle.valor = this.valorefectivo;
				pago_detalle.forma_pago_id = "1"; // EFECTIVO
				pago_detalle.debito_credito = "D";
				pago_detalle.empresa_id = this.ss.getData("empresa_id");
				pago_detalle.sucursal_id = this.ss.getData("sucursal_id");
				pago_detalle.usuario_id = this.ss.getData("usuario_id");
				this.pago.detalle.push(pago_detalle);
			}
	
			this.cheques.forEach(ch => {
				let pago_detalle = new PagoDetalle();
	
				pago_detalle.fecha_cheque = ch.fecha;
				pago_detalle.numero_cta = ch.cuenta;
				pago_detalle.numero_cheque = ch.numero;
				pago_detalle.banco_id = ch.banco_id;
				pago_detalle.observacion = ch.observacion;
	
				pago_detalle.valor = ch.valor;
				pago_detalle.forma_pago_id = ch.forma_pago_id; // CHEQUE
				pago_detalle.empresa_id = this.ss.getData("empresa_id");
				pago_detalle.sucursal_id = this.ss.getData("sucursal_id");
				pago_detalle.usuario_id = this.ss.getData("usuario_id");
				this.pago.detalle.push(pago_detalle);
			});
	
			this.tarjetas.forEach(tr => {
				let pago_detalle = new PagoDetalle();
	
				pago_detalle.debito_credito = tr.debito_credito;
				pago_detalle.observacion = tr.observacion;
				pago_detalle.tipo_tarjeta_id = tr.tipo_id;
				pago_detalle.valor = tr.valor;
				pago_detalle.plazo = tr.plazo;
				pago_detalle.tiempo = tr.tiempo;
				pago_detalle.forma_pago_id = tr.forma_pago_id; // TARJETA
				pago_detalle.empresa_id = this.ss.getData("empresa_id");
				pago_detalle.sucursal_id = this.ss.getData("sucursal_id");
				pago_detalle.usuario_id = this.ss.getData("usuario_id");
				this.pago.detalle.push(pago_detalle);
			});

			this.transferencias.forEach(tr => {
				let pago_detalle = new PagoDetalle();
	
				pago_detalle.fecha_transferencia = tr.fecha;
				pago_detalle.numero_cta = tr.cuenta;
				pago_detalle.numero_comprobante = tr.numero;
				pago_detalle.banco_id = tr.banco_id;
				pago_detalle.observacion = tr.observacion;
	
				pago_detalle.valor = tr.valor;
				pago_detalle.forma_pago_id = tr.forma_pago_id; // TRANSFERENCIA
				pago_detalle.empresa_id = this.ss.getData("empresa_id");
				pago_detalle.sucursal_id = this.ss.getData("sucursal_id");
				pago_detalle.usuario_id = this.ss.getData("usuario_id");
				this.pago.detalle.push(pago_detalle);
			});
		}else{
			let pago_detalle = new PagoDetalle();
			pago_detalle.valor = this.compra.total;
			pago_detalle.forma_pago_id = "1"; // EFECTIVO
			pago_detalle.debito_credito = "D";
			pago_detalle.empresa_id = this.ss.getData("empresa_id");
			pago_detalle.sucursal_id = this.ss.getData("sucursal_id");
			pago_detalle.usuario_id = this.ss.getData("usuario_id");
			this.pago.detalle.push(pago_detalle);


			// this.cheques.forEach(ch => {
			// 	let pago_detalle = new PagoDetalle();
	
			// 	pago_detalle.fecha_cheque = ch.fecha;
			// 	pago_detalle.numero_cta = ch.cuenta;
			// 	pago_detalle.numero_cheque = ch.numero;
			// 	pago_detalle.banco_id = ch.banco_id;
			// 	pago_detalle.observacion = ch.observacion;
	
			// 	pago_detalle.valor = ch.valor;
			// 	pago_detalle.forma_pago_id = ch.forma_pago_id; // CHEQUE
			// 	pago_detalle.empresa_id = this.ss.getData("empresa_id");
			// 	pago_detalle.sucursal_id = this.ss.getData("sucursal_id");
			// 	pago_detalle.usuario_id = this.ss.getData("usuario_id");
			// 	this.pago.detalle.push(pago_detalle);
			// });
	
			// this.tarjetas.forEach(tr => {
			// 	let pago_detalle = new PagoDetalle();
	
			// 	pago_detalle.debito_credito = tr.debito_credito;
			// 	pago_detalle.observacion = tr.observacion;
			// 	pago_detalle.tipo_tarjeta_id = tr.tipo_id;
			// 	pago_detalle.valor = tr.valor;
			// 	pago_detalle.plazo = tr.plazo;
			// 	pago_detalle.tiempo = tr.tiempo;
			// 	pago_detalle.forma_pago_id = tr.forma_pago_id; // TARJETA
			// 	pago_detalle.empresa_id = this.ss.getData("empresa_id");
			// 	pago_detalle.sucursal_id = this.ss.getData("sucursal_id");
			// 	pago_detalle.usuario_id = this.ss.getData("usuario_id");
			// 	this.pago.detalle.push(pago_detalle);
			// });
	
			
		}

		
		console.log(this.pago.detalle);
		console.log(this.tarjetas);
	}

	// setValueEntity(){
	//     this.compra.is_secuencial_manual = this.is_numero_manual;
	//     if( this.is_numero_manual ) this.venta.numero_documento = this.numero_documento;
	//     this.compra.cliente_id = this.cliente.id;
	//     this.compra.cliente = this.cliente;
	//     this.compra.caja_id = this.caja.id;
	//     this.compra.fecha_emision = moment(this.fecha_emision).format("YYYY-MM-DD")
	//     this.compra.usuario_id = this.ss.getData('usuario_id');
	//     this.compra.empresa_id = this.ss.getData('empresa_id');
	//     this.compra.sucursal_id = this.ss.getData('sucursal_id');
	//     this.compra.cobros.push(this.cobro);

	//     this.comprasDetalle.forEach(detalle => {
	//         if( parseInt(this.compra.tipo_comprobante_id.toString()) === 1 || parseInt(this.venta.tipo_comprobante_id.toString()) === 4 ){
	//             if( !detalle.graba_iva ){
	//                 detalle.iva = 0;
	//             }else{
	//                 detalle.iva = detalle.subtotal * this.IVA;
	//             }
	//         }else{
	//             detalle.iva = 0;
	//         }
	//         if( detalle.desc_porcent > 0  ){
	//             let total = this.utils.redondear((detalle.precio_unitario * detalle.cantidad),this.calculo_decimales);
	//             let desc_valor = total * (detalle.desc_porcent / 100);
	//             
	//             //detalle.desc_valor = Math.round(desc_valor * 100) / 100;
	//             detalle.desc_valor = this.utils.redondear(desc_valor,this.calculo_decimales);
	//         }
	//         detalle.total = detalle.subtotal + detalle.iva;
	//     });

	//     this.compra.detalle = this.ventasDetalle;

	//     this.amortizacion.valor = this.saldoCuotas();
	//     this.amortizacion.numero_cuotas = this.amortizacion.detalle.length;
	//     this.amortizacion.empresa_id = this.ss.getData('empresa_id');
	//     this.amortizacion.usuario_id = this.ss.getData('usuario_id');
	//     this.venta.amortizacion = this.amortizacion;
	// }

	onSubmit() {
		this.msgSweet.showMessage('delete-confirm-message', "¿Está seguro de confirmar la compra?").then(
			res => {
				
				this.setValuePagos();
				// this.setValueEntity();
				this.setValueAmortizacion();
				//this.compra.
				this.compra.fecha_emision = moment(this.fecha_emision).format("YYYY-MM-DD")

				this.compra.detalle = this.compras;

				// this.compra.lote = this.compras;
				this.compra.pagos.push(this.pago);
				this.compra.usuario_id = this.ss.getData('usuario_id');
				this.compra.empresa_id = this.ss.getData('empresa_id');
				this.compra.sucursal_id = this.ss.getData('sucursal_id');
				this.compra.proveedor_id = this.proveedor.id;
				let tipo_comprobante_id = "";
				if (this.Mod_FactElec) {
					this.compra.tipo_comprobante_id = "4";
				}

				if( !this.Mod_Cartera ){
					this.compra.tipo = "CO";
				}
				// this.loading = true;
				if( this.Mod_Cartera && this.Mod_Contabilidad ){

                    this.getPeriodoActual().then(
                        res => {
                            this.setValueAsientoContable();
							   this.saveCompra();   
                        }
                    );
                }else {
                   this.saveCompra();   
                }

				
			}
		);
	}

	saveCompra(){
		this.loading = true;
		this.compra.numero_documento = this.compra.serie + "-" + this.compra.punto_emision + "-" + this.compra.secuencial;
		let qs = this.Mod_Contabilidad ? '?asiento=true' : '';
		this.CompraService.save(this.compra,qs).subscribe(
			res => {
				this.compra_id = res.id;
				let bodega_id = this.compra.bodega_id;
				this.compra = new Compra();
				this.compra.bodega_id = bodega_id;
				this.proveedor = new Proveedor();
				this.pago = new Pago();

				this.cheques = [];
				this.tarjetas = [];
				this.transferencias = [];
				this.valorefectivo = 0;



				this.datosPagos.total_cheque = 0;
				this.datosPagos.total_tarjeta = 0;
				this.datosPagos.total_efectivo = 0;
				this.datosPagos.total_transferencia = 0;
				//this.correos = [];
				this.compras = [];
				this.total_pago = 0;
				//this.onIniDate();
				this.amortizacion = new Amortizacion();
				this.compra.tipo_comprobante_id = this.tipos[0].id;

				this.msgSweet.showMessage('success-message', 'Se ha procesado correctamente - CAMBIO: ' + numeral(this.cambio).format("0,0.00"));
				this.cambio = 0;
				this.loading = false;
				this.retencion = true;
				this.forma_pago_facturacion_id = "";
			},
			err => {
				this.loading = false;
				this.compra.asientosContables = [];
				this.msgSweet.showMessage('error-message', err);
			}
		);
	}

	isValidForm() {
		if (!this.proveedor.id) {
			return false;
		}
		if (!this.compra.proveedor) {
			return false;
		}
		if (!this.compra.numero_autorizacion) {
			return false;
		}

		// let productos = this.compras.filter((c: CompraDetalle) => c.es_servicio);

		let productos = this.compras.filter((c: CompraDetalle) => c.tipo_producto_id == '2');
		if (!productos.length) {
			if (!this.compra.bodega_id) {
				return false;
			}
		}
		if (this.compra.serie == undefined || this.compra.serie.toString().trim().length === 0 ) {
			return false;
		}
		if (this.compra.punto_emision == undefined || this.compra.punto_emision.toString().trim().length === 0 ) {
			return false;
		}
		if (this.compra.secuencial == undefined  || this.compra.secuencial.toString().trim().length === 0 ) {
			return false;
		}
		if (!this.vl.validDate(this.fecha_emision.toString())) {
			return false;
		}
		/*if( !this.vl.validDate(this.fecha_emision.toString()) ){
			return false;
		}*/
		if (this.fecha_emision.toString().trim().length === 0) {
			return false;
		}
		if (!this.compras.length) {
			return false;
		}
		if (!this.compra.tipo) {
			return false;
		}
		if (this.compra.tipo === "CO") {
			//let total_pago = Math.round(this.total_pago * 100) / 100;
			let total_pago = this.utils.redondear(this.total_pago, this.calculo_decimales);
			//let compra_total = Math.round(this.compra.total * 100) / 100;
			let compra_total = this.utils.redondear(this.compra.total, this.calculo_decimales);

			if( this.Mod_Cartera ){
				if (parseFloat(total_pago.toString()) < parseFloat(compra_total.toString())) {
					return false;
				}
			}else{
				if( !this.forma_pago_facturacion_id){
                    return false;
                }
			}
		}
		/*else{
			if(!this.isValidFormCuotas()){
				return false;
			}
		}*/
		// if(this.Mod_FactElec){
		// 	if (this.fecha_emision < this.fecha_MesAnt) {
		// 		return false;
		// 	}
		// }

		let b = false;
		this.compras.forEach(item => {
			
			if (item.cantidad < 1 || item.precio_unitario == 0 ) {
				b = true;
			}
		});
		if (b) {
			return false;
		}

		if (this.compra.numero_documento.toString().trim().length === 0) {
			return false;
		}
		

		return true;
	}

	isCheckedCredito() {
		if (this.compra.tipo == "CR") {
			return false;
		}
		return true;
	}

	onDelete(i) {

		this.compras.splice(i, 1);
		this.recalcularFactura();
		this.calcularCuotasCredito();
	}

	calcularTotal(total) {
		this.total_pago = total;

		//CALCULAR CAMBIO
		let saldo = this.compra.total - this.compra.abonado;

		if (this.compra.retencion) {
			saldo = saldo - this.compra.retencion.total;
		}

		this.cambio = (this.total_pago > saldo ? (this.total_pago - saldo) : 0);
		//this.cambio = Math.round( this.cambio * 100) / 100;
		this.cambio = this.utils.redondear(this.cambio, this.calculo_decimales);
		this.calcularCuotasCredito();
	}

	onChangeEfectivo(total) {
		this.calcularCuotasCredito();
		this.valorefectivo = total;
	}

	uploadLogo(event) {
		
		//this.logo = event.target.files[0];		
	}

	openModalCredito(template: TemplateRef<any>) {
		//if(this.compra.tipo == "CR"){
		this.valorefectivo = 0;
		this.cheques = [];
		this.tarjetas = [];
		this.transferencias = [];
		this.total_pago = 0;
		this.cambio = 0;
		//}

		this.bsModalRef = this.modalService.show(template);
		//this.modalService.onDismiss

	}


	openModalCargaXML(template: TemplateRef<any>) {
		this.paso = 1;
		this.comprasXML = [];
		this.bsModalRefC = this.modalService.show(template, { backdrop: 'static', class: 'modal-xlg' });
	}

	next() {
		this.paso++;
		//	this.isValidBotones();
		this.permitirBotones = false;

		if (this.paso == 2) {
			this.getProveedor();
		}

		if (this.paso == 3) {
			let compras = this.comprasXML.filter((c) => c.producto.nombreEquivalente == "");
			if (!compras.length) {
				this.permitirBotones = true;
			} else
				this.permitirBotones = false;
		}
		if (this.paso == 4) {
			this.bsModalRefC.hide();
			this.comprasXML.forEach(e => {
				e.producto.nombre = e.producto.nombreEquivalente;
			});
			this.compras = this.comprasXML;
			this.compras.forEach(compraDetalle => {
				this.recalcularItem(compraDetalle);
			});
			this.comprasXML = [];
			this.paso = 1;
			this.msgSweet.showMessage('single-message', "Verifique los datos de la factura");
		}
	}

	previous() {
		this.paso--;
		this.permitirBotones = false;
		if (this.paso == 1) {
			this.comprasXML = [];
		}
		if (this.paso == 2) {
			this.permitirBotones = true;
		}
		//	this.isValidBotones();
	}

	addCuota() {
		//let cuota = new Cuota();
		let item = new AmortizacionDetalle();
		this.amortizacion.detalle.push(item);
		//if(this.compra.tipo == "CR"){
		this.valorefectivo = 0;
		this.cheques = [];
		this.tarjetas = [];
		this.transferencias = [];
		//}
		this.calcularCuotasCredito();
	}

	calcularCuotasCredito() {
		let saldo_credito = parseFloat(this.compra.total.toString()) - parseFloat(this.total_pago.toString());

		//let valor_cuota = Math.round((saldo_credito / this.amortizacion.detalle.length) * 100) / 100;
		let valor_cuota = this.utils.redondear((saldo_credito / this.amortizacion.detalle.length), this.calculo_decimales);

		let acumulado = 0;


		let now = moment();
		let fecha = moment(now.format(), moment.ISO_8601).format();


		this.amortizacion.detalle.forEach((item, i) => {

			if ((i + 1) === this.amortizacion.detalle.length) {
				item.cuota = saldo_credito - acumulado;
				//item.cuota = Math.round(item.cuota * 100) / 100;
				item.cuota = this.utils.redondear(item.cuota, this.calculo_decimales);


				let now = moment();
				let fecha = moment(now.format(), moment.ISO_8601).add((i + 1), 'month').format();
				item.fecha_vencimiento = fecha;
			} else {
				acumulado += valor_cuota;
				item.cuota = valor_cuota;

				let now = moment();
				let fecha = moment(now.format(), moment.ISO_8601).add((i + 1), 'month').format();
				item.fecha_vencimiento = fecha;
			}

		});
	}

	saldoCuotas() {
		return parseFloat(this.compra.total.toString()) - parseFloat(this.total_pago.toString());
	}


	removeCuota(i) {
		//this.cuotas_credito.splice(i,1);
		this.amortizacion.detalle.splice(i, 1);
		this.calcularCuotasCredito();
	}


	getTotalCuotasCredito() {
		let total = 0;

		this.amortizacion.detalle.forEach(item => {
			total += item.cuota.toString().length === 0 ? 0 : (parseFloat(item.cuota.toString()));
		});

		total = this.utils.redondear(total, this.calculo_decimales);

		return total;
	}

	setValueAmortizacion() {
		this.amortizacion.valor = this.saldoCuotas();
		this.amortizacion.numero_cuotas = this.amortizacion.detalle.length;
		this.amortizacion.empresa_id = this.ss.getData('empresa_id');
		this.amortizacion.usuario_id = this.ss.getData('usuario_id');
		this.compra.amortizacion = this.amortizacion;
	}

	isValidFormCuotas() {
		let totalCuotas = this.getTotalCuotasCredito();
		let ventaTotal = this.compra.total;
		let total_abonado = this.total_pago;
		if ((totalCuotas + total_abonado) != ventaTotal) {
			return false;
		}
		return true;
	}

	uploadXLM(event) {
		this.file = event.target.files[0];
		let fr = new FileReader();
		this.proveedor = new Proveedor();
		let promise = new Promise((resolve, reject) => {
			fr.onload = (e) => {
				let xml = fr.result;
				xml2js.parseString(xml, (err, result) => {
					if (err) reject(err);
					//resolve(result);
					this.comprobante = result.autorizacion.comprobante[0];
				});
				xml2js.parseString(this.comprobante, { ignoreAttrs: false, mergeAttrs: true }, function (err, result) {
					if (err) reject(err);
					resolve(result);
				});
			}
		});

		promise.then(
			result => {
				this.compras = [];
				this.proveedor.dni = result['factura']['infoTributaria'][0]['ruc'][0];
				this.proveedor.razon_social = result['factura']['infoTributaria'][0]['razonSocial'][0];
				this.proveedor.nombre_comercial = result['factura']['infoTributaria'][0]['nombreComercial'][0];
				//this.proveedor.correo = result['factura']['infoTributaria'][0]['campoAdicional'][2];
				this.proveedor.telefono = '0999999999';
				//this.proveedor.correo = "sas";
				this.proveedor.direccion = result['factura']['infoTributaria'][0]['dirMatriz'][0];
				//this.proveedor.nombre_comercial = result['factura']['infoFactura'][0]['razonSocialComprador'];
				this.compra.serie = result['factura']['infoTributaria'][0]['estab'][0];
				this.compra.punto_emision = result['factura']['infoTributaria'][0]['ptoEmi'][0];
				this.compra.secuencial = result['factura']['infoTributaria'][0]['secuencial'][0];
				this.compra.numero_autorizacion = result['factura']['infoTributaria'][0]['claveAcceso'][0];
				this.fecha_emision = moment(result['factura']['infoFactura'][0]['fechaEmision'][0], "DD/MM/YYYY");
				this.compra.fecha_emision = this.fecha_emision;
				let detalles = result['factura']['detalles'][0]['detalle'];

				detalles.forEach(detalle => {
					let producto = new Producto();
					let compra_detalle = new CompraDetalle();
					compra_detalle.cantidad = detalle['cantidad'][0];
					compra_detalle.precio_unitario = detalle['precioUnitario'][0];
					compra_detalle.desc_valor = detalle['descuento'][0];
					compra_detalle.producto.codigo = detalle['codigoPrincipal'][0];
					compra_detalle.producto.nombre = detalle['descripcion'][0];
					// compra_detalle.es_servicio = Boolean(producto.es_servicio);
					compra_detalle.tipo_producto_id = detalle['tipo_producto_id'][0];
					compra_detalle.producto_id = producto.id;
					compra_detalle.usuario_id = this.ss.getData('usuario_id');
					compra_detalle.empresa_id = this.ss.getData('empresa_id');
					compra_detalle.sucursal_id = this.ss.getData('sucursal_id');
					this.comprasXML.push(compra_detalle);
				});

				//this.calcularCuotasCredito();
				this.permitirBotones = true;
			},
			err => {
				console.log(err);
			}
		);

		fr.readAsText(this.file, 'ISO-8859-4');
	}

	getProveedor() {
		this.loading = true;
		//this.permitirBotones = false;
		this.proveedorService.getByDni(this.proveedor.dni).subscribe(
			res => {
				this.loading = false;
				if (res.length <= 0) {
					this.permitirBotones = false;
				} else {
					this.proveedor = res[0];
					/*if( this.proveedor.correo.trim().length ){
						this.correos = this.proveedor.correo.split(',');
					}*/
					this.permitirBotones = true;
				}

			},
			err => {
				this.loading = false;
				//this.proveedor = new Proveedor();
			}
		);
	}

	onSubmitProveedor() {
		this.msgSweet.showMessage('delete-confirm-message', "¿Está seguro de confirmar el registro del proveedor?").then(
			res => {
				this.setValueEntityProveedor();
				this.loading = true;
				this.proveedorService.save(this.proveedor).subscribe(
					res => {
						this.loading = false;
						this.msgSweet.showMessage('success-message', res.message);
						this.permitirBotones = true;
						//this.proveedor = new Proveedor();
						//this.correos = [];
					},
					err => {
						this.loading = false;
						this.msgSweet.showMessage('error-message', err);
					}
				);
			}
		);
	}

	setValueEntityProveedor() {
		this.proveedor.empresa_id = this.ss.getData("empresa_id");
		this.proveedor.usuario_id = this.ss.getData("usuario_id");
		//this.proveedor.correo = this.correos.toString();
		//this.proveedor.correo = this.correos.toString();
		this.proveedor.tipo_persona = "J";
		this.proveedor.tipo_identificacion_id = 1;
		this.proveedor.celular = this.proveedor.telefono;
		this.proveedor.nombre_comercial = this.proveedor.razon_social;
		this.proveedor.tipo_dni = "RUC";
	}

	onChangeFecha(event) {
		/*if(event < this.fecha_MesAnt){
			this.msgSweet.showMessage('error-message', "No puede seleccionar fechas anteriores al mes");            
		}*/
	}

	openModalDetalle(template: TemplateRef<any>, compra_detalle: CompraDetalle) {
		this.detalle = compra_detalle.detalle;
		this.compra_detalle = compra_detalle;
		this.bsModalRef = this.modalService.show(template);
	}

	saveDetalle() {
		this.compra_detalle.detalle = this.detalle.toString().trim();
		this.detalle = "";
		this.bsModalRef.hide();
	}

	openModalLote(template: TemplateRef<any>, compra_detalle: CompraDetalle) {

		this.lote.codigo = compra_detalle.lote.codigo;
		this.lote.cantidad = compra_detalle.cantidad;
		this.fecha_elaboracion = compra_detalle.lote.fecha_elaboracion;
		this.fecha_expiracion = compra_detalle.lote.fecha_expiracion;
		this.compra_detalle = compra_detalle;
		this.bsModalRef = this.modalService.show(template);
	}

	openModalSerie(compra_detalle: CompraDetalle) {
		const initialState = { series: compra_detalle.series, numero_decimales: this.numero_decimales };
		this.bsModalRef = this.modalService.show(SerieIngresoModalComponent, Object.assign({backdrop: 'static',initialState }));

		this.bsModalRef.content.sendSeries.take(1).subscribe((value) => {
			compra_detalle.series = value;
			compra_detalle.cantidad = compra_detalle.series.length;
			this.recalcularItem(compra_detalle);
			
		});
	}

	onChangeFechaExpiracion(event) {
		if (event < this.fecha_elaboracion) {
			this.msgSweet.showMessage('error-message', "No puede seleccionar fechas anteriores a la fecha de elaboración");
		}
	}

	saveLote() {
		this.compra_detalle.lote.codigo = this.lote.codigo;
		this.compra_detalle.lote.fecha_elaboracion = moment(this.fecha_elaboracion).format("YYYY-MM-DD");
		this.compra_detalle.lote.fecha_expiracion = moment(this.fecha_expiracion).format("YYYY-MM-DD");
		this.compra_detalle.lote.fecha_emision = moment(this.fecha_emision).format("YYYY-MM-DD");
		this.compra_detalle.cantidad = this.lote.cantidad;
		this.lote.codigo = "";
		this.lote.fecha_elaboracion = "";
		this.lote.fecha_expiracion = "";
		this.recalcularItem(this.compra_detalle);
		this.bsModalRef.hide();

	}

	isValidFormLote() {
		if (!this.fecha_elaboracion && !this.fecha_expiracion) {
			return false;
		}
		if (!this.lote.codigo) {
			return false;
		}
		if (!this.lote.cantidad) {
			return false;
		}
		if (this.fecha_expiracion < this.fecha_elaboracion) {
			return false;
		}
		return true;
	}
	validErrorForm(campo) {
		return this.vl.validErrorForm(campo, this.myForm);
	}

	onSearchOrden() {
		const initialState = { numero_decimales: this.numero_decimales };
		this.bsModalRef = this.modalService.show(OrdenCompraAddModalComponent, Object.assign({}, { class: 'modal-xlg', initialState }));

		this.bsModalRef.content.sendOrden.take(1).subscribe((value) => {
			this.is_orden = true;
			this.getOrden(value.id);
		});
	}
	
	getOrden($id){
        let arrayPromise=[];
        return new Promise((resolve, reject)=>{
            this.ordenService.getById($id, "?embed=detalle,proveedor?embed=tipoidentificacion").subscribe(
                res => {
						this.orden = res.data;
                        this.proveedor = this.orden.proveedor;
                        this.compra.bodega_id = this.orden.bodega_id;

                        this.compras = [];
                        this.orden.detalle.forEach(item => {
                            let producto: any = {};
                            
                            arrayPromise.push(new Promise((resolve, reject)=>{
                                this.productoService.getWithPrice(this.compra.bodega_id, '?page=1&per_page=10&producto_id='+item.producto_id).subscribe(
                                    res => {
                                        if(res.data.length){
											let data1 = res.data[0];
                                            producto['unidad'] = data1.unidad;
                                            producto['codigo'] = data1.codigo;
                                            producto['cantidad_stock'] = data1.cantidad_stock;
											// producto['es_servicio'] = data1.es_servicio;
											producto['tipo_producto_id'] = data1.tipo_producto_id;
                                            producto['descripcion'] = data1.descripcion;
                                            producto['nombre'] = data1.nombre;
                                            producto['id'] = data1.id;
                                            producto['graba_iva'] =  data1.graba_iva;
                                            producto['precio'] = item.subtotal/item.cantidad;
											producto['cantidad'] = item.cantidad;
											let incluye_precio = true;
                                            this.sendObjectProducto(producto,incluye_precio);
                                        }
                                        else{
                                            this.msgSweet.showMessage('error-message', "El producto no tiene stock suficiente");

                                        }
                                        
                                        resolve(true);
                                    },
                                    err => {
                                        reject(err);
                                    }
                                );
                            }));
                        });

                        Promise.all(arrayPromise).then(
                            res=> resolve(true),
                            err=>reject(err)
                        );                  
                },
                err => {
                    this.orden = new OrdenCompra;
                    reject(err);
                }
            );
		});
	}
	
	validTypeMsgForm(nombre, campo) {
		return this.vl.validTypeMsgForm(nombre, campo, this.myForm);
	}

	onChangeFormasPagoFacturacion(){
        this.compra.forma_pago_facturacion_id = this.forma_pago_facturacion_id;
    }
}






// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/components/compras/compra-add/compra-add.component.ts